import { FC, useState } from 'react';
import useDetailsBooking from 'hooks/useDetailsBooking';
import { getUpdatePaymentMethodPageLink } from 'lib/links';
import { ScheduledPaymentCreditCardExpired } from '../ScheduledPaymentCreditCardExpired';
import { getPendingScheduledPayment } from 'lib/bookingInfo';
import { isCreditCardExpired } from 'lib/payments';

export const ScheduledPaymentCreditCardExpiredContainer: FC = () => {
  const { booking } = useDetailsBooking();
  const [now] = useState(() => new Date());

  if (booking.state === 'CANCELLED') return null;

  if (booking.flags.isChangeInProgress) return null;

  if (booking.flags.isFinalising) return null;

  const pendingPayment = getPendingScheduledPayment(booking);

  if (!pendingPayment?.creditCardPaymentAllocation.paymentMethod) return null;

  const { paymentMethod } = pendingPayment.creditCardPaymentAllocation;

  if (!isCreditCardExpired(now, paymentMethod)) return null;

  return (
    <ScheduledPaymentCreditCardExpired
      paymentDueDate={pendingPayment.deferredTo}
      cardType={paymentMethod.cardType}
      lastFourDigits={paymentMethod.lastFourDigits}
      updatePaymentMethodUrl={getUpdatePaymentMethodPageLink(booking.id)}
    />
  );
};
